export default __webpack_public_path__ + "static/Graphik-RegularItalic-Cy-Web-2f163eda9d1ede7660c0d17633ceed17.woff2";